import React from 'react';
import { financialCalculators } from './ConstantsFinancialCalculator';
import SharedHelmet from '.././Helmet';
const TITLE = 'الحواسب المالية - حواسب مجانية لحساب القروض والاستثمار  والعمليات المالية';
const DESCRIPTION = 'استكشف مجموعة الحواسب المالية المجانية، بما في ذلك حواسب القروض والاستثمار  والعمليات المالية.';
const KEYWORDS = 'الحواسب المالية، حواسب مجانية، حاسبة القروض، حاسبة الاستثمار،  حاسبة العمليات المالية';
const OG_URL = 'https://do-calculate.com/ar/financial-calculators';
function CalculatorsList() {
    return (
      <div>
        <div className="container rtl-container">
          <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
          <div>
            <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
            <hr />
            <div className="alert alert-secondary" role="alert">
              <p>{DESCRIPTION} </p>
            </div>
          </div>
          <hr />
          <table >
            <thead>
              <tr>
                <th >الحاسبة</th>
                <th >الوصف</th>
              </tr>
            </thead>
            <tbody>
              {financialCalculators.map((calculator, index) => (
                <tr key={index}>
                  <td>
                    <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                  </td>
                  <td><p>{calculator.description}</p></td>
                </tr>
              ))}
            </tbody>
          </table>
          <br />
        </div>
      </div>
    );
  }
export default CalculatorsList;
